"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBooleanState = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var useBooleanState = function (init) {
    var _a = tslib_1.__read((0, react_1.useState)(init), 2), state = _a[0], setState = _a[1];
    var setTrue = (0, react_1.useCallback)(function () {
        setState(true);
    }, []);
    var setFalse = (0, react_1.useCallback)(function () {
        setState(false);
    }, []);
    return [state, setTrue, setFalse];
};
exports.useBooleanState = useBooleanState;
